(function () {
  function setPos(root, range, percent) {
    var p = Math.max(0, Math.min(100, percent));
    root.style.setProperty('--compare-pos', p + '%');
    if (range) {
      range.value = String(Math.round(p));
      range.setAttribute('aria-valuenow', String(Math.round(p)));
    }
  }

  function percentFromEvent(root, clientX) {
    var rect = root.getBoundingClientRect();
    if (!rect.width) return 50;
    return ((clientX - rect.left) / rect.width) * 100;
  }

  function init(root) {
    if (root.getAttribute('data-compare-ready') === 'true') return;
    root.setAttribute('data-compare-ready', 'true');

    var range = root.querySelector('[data-compare-range]');
    var dragging = false;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (range) {
      setPos(root, range, Number(range.value) || 50);
      range.addEventListener('input', function () {
        setPos(root, range, Number(range.value));
      });
    }

    function move(clientX) {
      setPos(root, range, percentFromEvent(root, clientX));
    }

    root.addEventListener('pointerdown', function (e) {
      if (e.target === range) return;
      dragging = true;
      root.classList.add('is-dragging');
      try {
        root.setPointerCapture(e.pointerId);
      } catch (err) {}
      move(e.clientX);
    });

    root.addEventListener('pointermove', function (e) {
      if (dragging) {
        move(e.clientX);
        return;
      }
      /* Hover scrub on fine pointers (desktop) */
      if (e.pointerType === 'mouse' && !reduceMotion) {
        move(e.clientX);
      }
    });

    function endDrag(e) {
      if (!dragging) return;
      dragging = false;
      root.classList.remove('is-dragging');
      if (e && e.pointerId != null) {
        try {
          root.releasePointerCapture(e.pointerId);
        } catch (err) {}
      }
    }

    root.addEventListener('pointerup', endDrag);
    root.addEventListener('pointercancel', endDrag);
    root.addEventListener('pointerleave', function (e) {
      if (e.pointerType === 'mouse' && !dragging) return;
      endDrag(e);
    });
  }

  function boot() {
    document.querySelectorAll('[data-compare]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
